import { render, staticRenderFns } from "./LanguageSwitchDialog.vue?vue&type=template&id=76f53d1d"
import script from "./LanguageSwitchDialog.vue?vue&type=script&lang=js"
export * from "./LanguageSwitchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports